import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAsyncFn } from 'react-use/lib';
import { uploadFile } from 'libs/common/utils/uploadFile';

/**
 * Call `doUploadFile` to upload a file to the `file-upload` service.
 *
 * Usage:
 * ```typescriptreact
 * const { loading, doUploadFile } = useFileUpload();
 * const url = await doUploadFile(file);
 * ```
 * `url` is the url where the file will be publicly accessible.
 */
var useFileUpload = function useFileUpload() {
  var intl = useIntl();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      var _yield$uploadFile, cdnFileUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return uploadFile(file);

            case 3:
              _yield$uploadFile = _context.sent;
              cdnFileUrl = _yield$uploadFile.cdnFileUrl;
              enqueueSnackbar(intl.formatMessage({
                id: 'image-upload.success'
              }), {
                variant: 'success'
              });
              return _context.abrupt("return", cdnFileUrl);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              enqueueSnackbar(intl.formatMessage({
                id: 'image-upload.error'
              }), {
                variant: 'error'
              });
              throw _context.t0;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      _useAsyncFn2$ = _useAsyncFn2[0],
      loading = _useAsyncFn2$.loading,
      error = _useAsyncFn2$.error,
      doUploadFile = _useAsyncFn2[1];

  useEffect(function () {
    if (error) {
      enqueueSnackbar(intl.formatMessage({
        id: 'image-upload.error'
      }), {
        variant: 'error'
      });
    }
  }, [error, enqueueSnackbar, intl]);
  return {
    loading: loading,
    doUploadFile: doUploadFile
  };
};

export default useFileUpload;